import { PushNotifications } from '@capacitor/push-notifications';
import { useNotifications } from '@/composables/useNotifications';
import { getDeviceInfo } from '@/plugins/device';

const { handleRegisterDevice, handleClickNotification } = useNotifications();

/**
 * @function notificationServiceInit
 *
 * this function run the workers to received push notifications
 */
export async function notificationServiceInit() {
  const device = await getDeviceInfo();
  if (device.platform === 'web') {
    return;
  }

  let permStatus = await PushNotifications.checkPermissions();

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }

  if (permStatus.receive !== 'granted') {
    throw new Error('User denied permissions!');
  }

  PushNotifications.addListener('registration', (token) => {
    console.log('Token device', token.value);
    handleRegisterDevice(token.value);
  });

  PushNotifications.addListener('registrationError', (error: any) => {
    console.log('Error registrationError: ' + JSON.stringify(error));
  });

  PushNotifications.addListener('pushNotificationReceived', async (notification) => {
    const { data } = notification;
    console.log('pushNotificationReceived: ' + JSON.stringify(data));

    // get all unread notifications to increment counter
    const { handleGetNotifications } = useNotifications();
    handleGetNotifications();
  });

  PushNotifications.addListener('pushNotificationActionPerformed', async (notification) => {
    const data = notification.notification.data;

    if (data.actionId) {
      handleClickNotification(data.id, data.type, data.actionId);
    }
  });

  PushNotifications.checkPermissions().then((permission) => {
    if (permission.receive === 'granted') {
      // Register with Apple / Google to receive push via APNS/FCM
      PushNotifications.register();
    } else {
      // No permission for push granted
      throw new Error('No permission for push notifications granted!');
    }
  });
}
